import Storage from 'common/services/Storage';
import { DataTableData, OrderData } from './models';

const TABLE_SUFFIX = '_DATA_TABLE';

export const DEFAULT_TABLE_DATA: DataTableData<any, any> = {
    order: { field: 'name', isOrderAsc: true },
    hiddenColumns: [],
    columnsOrder: [],
    columnsWidth: [],
    page: 1,
    filters: {},
    lastRowId: null,
};

class DataTableCache {
    public save<TRow, TFilters>(pageId: string, data: DataTableData<TRow, TFilters>) {
        // Don't persist page number - always start from page 1
        const { page, ...dataWithoutPage } = data;
        Storage.setObject(pageId + TABLE_SUFFIX, dataWithoutPage);
    }

    public get<TRow, TFilters>(pageId: string, defaultData?: DataTableData<TRow, TFilters>): DataTableData<TRow, TFilters> {
        const result: DataTableData<TRow, TFilters> = Storage.getObject(pageId + TABLE_SUFFIX) ?? defaultData ?? DEFAULT_TABLE_DATA;
        if (!result.filters) {
            (result as any).filters = {};
        }
        if (!result.hiddenColumns) {
            result.hiddenColumns = [];
        }
        if (!result.columnsOrder) {
            result.columnsOrder = [];
        }
        if (!result.columnsWidth) {
            result.columnsWidth = [];
        }
        // Always reset page to 1 when loading from cache
        result.page = 1;
        return result;
    }

    public saveLastRowId(pageId: string, lastRowId: string) {
        const data = this.get(pageId, DEFAULT_TABLE_DATA);
        data.lastRowId = lastRowId;
        this.save(pageId, data);
    }

    public updateOrder<TRow, TFilters>(pageId: string, order: OrderData<TRow>) {
        const data = this.get<TRow, TFilters>(pageId, DEFAULT_TABLE_DATA as DataTableData<TRow, TFilters>);
        data.order = order;
        this.save(pageId, data);
    }

    public updateHiddenColumns<TRow, TFilters>(pageId: string, hiddenColumns: string[]) {
        const data = this.get<TRow, TFilters>(pageId, DEFAULT_TABLE_DATA as DataTableData<TRow, TFilters>);
        data.hiddenColumns = hiddenColumns;
        this.save(pageId, data);
    }

    public clear(pageId: string) {
        Storage.remove(pageId + TABLE_SUFFIX);
    }
}

export default new DataTableCache();
